export const MODAL_URL_PREFIX = "modal-";
export const MODAL_URL_HASH_ENTITY_TYPE = {
  TIME_ENTRY: "time-entry",
} as const;
export const MODAL_HASH_REGEX = new RegExp(`${MODAL_URL_PREFIX}([a-zA-Z]+(?:-[a-zA-Z]+)*)-(\\d+)`, "i");
